export const vercelModels = {
    id: "vercel",
    name: "Vercel AI Gateway",
    npm: "@ai-sdk/gateway",
    doc: "https://github.com/vercel/ai/tree/5eb85cc45a259553501f535b8ac79a77d0e79223/packages/gateway",
    env: ["AI_GATEWAY_API_KEY"],
    models: {
        "deepseek/deepseek-r1": {
            id: "deepseek/deepseek-r1",
            name: "DeepSeek-R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.35,
                output: 5.4,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "deepseek/deepseek-r1-distill-llama-70b": {
            id: "deepseek/deepseek-r1-distill-llama-70b",
            name: "DeepSeek R1 Distill Llama 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.75,
                output: 0.99,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "meta/llama-4-scout": {
            id: "meta/llama-4-scout",
            name: "Llama-4-Scout-17B-16E-Instruct-FP8",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "meta/llama-3.3-70b": {
            id: "meta/llama-3.3-70b",
            name: "Llama-3.3-70B-Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "meta/llama-4-maverick": {
            id: "meta/llama-4-maverick",
            name: "Llama-4-Maverick-17B-128E-Instruct-FP8",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "xai/grok-3-mini-fast": {
            id: "xai/grok-3-mini-fast",
            name: "Grok 3 Mini Fast",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.6,
                output: 4,
                reasoning: 4,
                cache_read: 0.15,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "xai/grok-4": {
            id: "xai/grok-4",
            name: "Grok 4",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-09",
            last_updated: "2025-07-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                reasoning: 15,
                cache_read: 0.75,
            },
            limit: {
                context: 256000,
                output: 64000,
            },
        },
        "xai/grok-3-fast": {
            id: "xai/grok-3-fast",
            name: "Grok 3 Fast",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 5,
                output: 25,
                cache_read: 1.25,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "xai/grok-2-vision": {
            id: "xai/grok-2-vision",
            name: "Grok 2 Vision",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 8192,
                output: 4096,
            },
        },
        "xai/grok-2": {
            id: "xai/grok-2",
            name: "Grok 2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-20",
            last_updated: "2024-08-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 10,
                cache_read: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "xai/grok-3-mini": {
            id: "xai/grok-3-mini",
            name: "Grok 3 Mini",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 0.5,
                reasoning: 0.5,
                cache_read: 0.075,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "xai/grok-3": {
            id: "xai/grok-3",
            name: "Grok 3",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2025-02-17",
            last_updated: "2025-02-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "cerebras/qwen3-coder": {
            id: "cerebras/qwen3-coder",
            name: "Qwen 3 Coder 480B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 2,
            },
            limit: {
                context: 131000,
                output: 32000,
            },
        },
        "anthropic/claude-4-opus": {
            id: "anthropic/claude-4-opus",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-3.5-sonnet": {
            id: "anthropic/claude-3.5-sonnet",
            name: "Claude Sonnet 3.5 v2",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04-30",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "anthropic/claude-3.7-sonnet": {
            id: "anthropic/claude-3.7-sonnet",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-31",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic/claude-4-sonnet": {
            id: "anthropic/claude-4-sonnet",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic/claude-3-haiku": {
            id: "anthropic/claude-3-haiku",
            name: "Claude Haiku 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-08-31",
            release_date: "2024-03-13",
            last_updated: "2024-03-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 1.25,
                cache_read: 0.03,
                cache_write: 0.3,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "anthropic/claude-3-opus": {
            id: "anthropic/claude-3-opus",
            name: "Claude Opus 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-08-31",
            release_date: "2024-02-29",
            last_updated: "2024-02-29",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "anthropic/claude-4-1-opus": {
            id: "anthropic/claude-4-1-opus",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-3-5-haiku": {
            id: "anthropic/claude-3-5-haiku",
            name: "Claude Haiku 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07-31",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 4,
                cache_read: 0.08,
                cache_write: 1,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "openai/gpt-oss-20b": {
            id: "openai/gpt-oss-20b",
            name: "GPT OSS 20B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.07,
                output: 0.3,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.5,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "openai/o3-mini": {
            id: "openai/o3-mini",
            name: "o3-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2024-12-20",
            last_updated: "2025-01-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.55,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/o4-mini": {
            id: "openai/o4-mini",
            name: "o4-mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.28,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/gpt-4o": {
            id: "openai/gpt-4o",
            name: "GPT-4o",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-05-13",
            last_updated: "2024-05-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2.5,
                output: 10,
                cache_read: 1.25,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-4.1-mini": {
            id: "openai/gpt-4.1-mini",
            name: "GPT-4.1 mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 1.6,
                cache_read: 0.1,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-4.1-nano": {
            id: "openai/gpt-4.1-nano",
            name: "GPT-4.1 nano",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.03,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-4o-mini": {
            id: "openai/gpt-4o-mini",
            name: "GPT-4o mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.08,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-5-mini": {
            id: "openai/gpt-5-mini",
            name: "GPT-5 Mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 2,
                cache_read: 0.03,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/o3": {
            id: "openai/o3",
            name: "o3",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/gpt-5": {
            id: "openai/gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-09-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.13,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/o1": {
            id: "openai/o1",
            name: "o1",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-12-05",
            last_updated: "2024-12-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 60,
                cache_read: 7.5,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "openai/gpt-4-turbo": {
            id: "openai/gpt-4-turbo",
            name: "GPT-4 Turbo",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2023-11-06",
            last_updated: "2024-04-09",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 10,
                output: 30,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "openai/gpt-4.1": {
            id: "openai/gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-5-nano": {
            id: "openai/gpt-5-nano",
            name: "GPT-5 Nano",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.05,
                output: 0.4,
                cache_read: 0.01,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "mistral/mixtral-8x22b-instruct": {
            id: "mistral/mixtral-8x22b-instruct",
            name: "Mixtral 8x22B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-04-17",
            last_updated: "2024-04-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 64000,
                output: 64000,
            },
        },
        "mistral/mistral-small": {
            id: "mistral/mistral-small",
            name: "Mistral Small",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03",
            release_date: "2024-09-01",
            last_updated: "2024-09-04",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.3,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "mistral/pixtral-large": {
            id: "mistral/pixtral-large",
            name: "Pixtral Large",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2024-11-01",
            last_updated: "2024-11-04",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral/ministral-3b": {
            id: "mistral/ministral-3b",
            name: "Ministral 3B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-10-01",
            last_updated: "2024-10-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.04,
                output: 0.04,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral/magistral-medium": {
            id: "mistral/magistral-medium",
            name: "Magistral Medium",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-03-17",
            last_updated: "2025-03-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 5,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "mistral/magistral-small": {
            id: "mistral/magistral-small",
            name: "Magistral Small",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-06",
            release_date: "2025-03-17",
            last_updated: "2025-03-17",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 1.5,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral/pixtral-12b": {
            id: "mistral/pixtral-12b",
            name: "Pixtral 12B",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2024-09-01",
            last_updated: "2024-09-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.15,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral/codestral": {
            id: "mistral/codestral",
            name: "Codestral",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-05-29",
            last_updated: "2025-01-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 0.9,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "mistral/ministral-8b": {
            id: "mistral/ministral-8b",
            name: "Ministral 8B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-10-01",
            last_updated: "2024-10-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 128000,
                output: 128000,
            },
        },
        "mistral/mistral-large": {
            id: "mistral/mistral-large",
            name: "Mistral Large",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11",
            release_date: "2024-11-01",
            last_updated: "2024-11-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 6,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
        "vercel/v0-1.0-md": {
            id: "vercel/v0-1.0-md",
            name: "v0-1.0-md",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
            },
            limit: {
                context: 128000,
                output: 32000,
            },
        },
        "vercel/v0-1.5-md": {
            id: "vercel/v0-1.5-md",
            name: "v0-1.5-md",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-06-09",
            last_updated: "2025-06-09",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
            },
            limit: {
                context: 128000,
                output: 32000,
            },
        },
        "google/gemini-2.0-flash": {
            id: "google/gemini-2.0-flash",
            name: "Gemini 2.0 Flash",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.025,
            },
            limit: {
                context: 1048576,
                output: 8192,
            },
        },
        "google/gemini-2.5-flash": {
            id: "google/gemini-2.5-flash",
            name: "Gemini 2.5 Flash",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-03-20",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 2.5,
                cache_read: 0.075,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemini-2.0-flash-lite": {
            id: "google/gemini-2.0-flash-lite",
            name: "Gemini 2.0 Flash Lite",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.075,
                output: 0.3,
            },
            limit: {
                context: 1048576,
                output: 8192,
            },
        },
        "google/gemini-2.5-pro": {
            id: "google/gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-03-20",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "amazon/nova-micro": {
            id: "amazon/nova-micro",
            name: "Nova Micro",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.035,
                output: 0.14,
                cache_read: 0.00875,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "amazon/nova-lite": {
            id: "amazon/nova-lite",
            name: "Nova Lite",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.06,
                output: 0.24,
                cache_read: 0.015,
            },
            limit: {
                context: 300000,
                output: 8192,
            },
        },
        "amazon/nova-pro": {
            id: "amazon/nova-pro",
            name: "Nova Pro",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 3.2,
                cache_read: 0.2,
            },
            limit: {
                context: 300000,
                output: 8192,
            },
        },
        "morph/morph-v3-large": {
            id: "morph/morph-v3-large",
            name: "Morph v3 Large",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-08-15",
            last_updated: "2024-08-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.9,
                output: 1.9,
            },
            limit: {
                context: 32000,
                output: 32000,
            },
        },
        "morph/morph-v3-fast": {
            id: "morph/morph-v3-fast",
            name: "Morph v3 Fast",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            release_date: "2024-08-15",
            last_updated: "2024-08-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 1.2,
            },
            limit: {
                context: 16000,
                output: 16000,
            },
        },
        "moonshotai/kimi-k2": {
            id: "moonshotai/kimi-k2",
            name: "Kimi K2 Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
    },
};
export default vercelModels;
//# sourceMappingURL=vercel.js.map